import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function BreakingTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/articles", { params: { breaking: true, limit: 8 } })
      .then(r => setItems(r.data.items || []))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  const repeated = [...items, ...items];
  return (
    <div className="bg-black text-white overflow-hidden border-b border-red-700" data-testid="breaking-ticker">
      <div className="max-w-7xl mx-auto flex items-center">
        <span className="bg-red-700 text-white px-4 py-2 font-sans-ui text-xs uppercase tracking-widest font-bold flex-shrink-0">Urgente</span>
        <div className="flex-1 overflow-hidden">
          <div className="ticker-track py-2">
            {repeated.map((a, i) => (
              <Link key={i} to={`/noticia/${a.slug}`} className="font-sans-ui text-sm mx-8 hover:text-red-300 whitespace-nowrap">
                {a.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
